import ax from "axios";
import JwtService from "@/core/services/jwt.service";
import {LOGOUT} from "@/core/services/store/auth.module";

export const axios = ax.create();
window.axios = axios;

axios.interceptors.response.use((response)=>{
    try{
        response.data =  window.Vue.$responseTranslate(response.data);
    }catch (e) {}
    return response;
} , (response)=>{
    try{
        response.response.data =  window.Vue.$responseTranslate(response.response.data);
    }catch (e) {}
    return Promise.reject(response);
})

let CoreAPIUrl = process.env.VUE_APP_CoreLandUrl
let CoreSecret = process.env.VUE_APP_CoreSecret
let APIUrl = process.env.VUE_APP_API_URL

function checkToken(token) {
    axios.get(`${CoreAPIUrl}/api/user`, {
        headers: {
            secret: CoreSecret,
            Authorization: `Bearer ${token}`
        }
    }).then(res => {
        if (res.status === 200) {
            localStorage.setItem('user_info', JSON.stringify(res.data));
            // this.$router.push({name: 'dashboard'})
        }
    }).catch(({response}) => {
        if (response.status === 401) {

            this.$store
                .dispatch(LOGOUT)
                .then(() => window.location.replace(`${this.$sarveLandFront}`));
        }
    });
}

function saveToken(token) {
    localStorage.setItem('id_token', token);
    this.$router.push('/dashboard');
}


function header() {
    return {
        Authorization: JwtService.getToken() ? `Bearer ${JwtService.getToken()}` : null,
        Accept: 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
        'Content-Type': 'application/json',
    };
}

function coreHeader() {
    return {
        Authorization: JwtService.getToken() ? `Bearer ${JwtService.getToken()}` : null,
        secret: CoreSecret,
        Accept: 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
        'Content-Type': 'application/json',
    };
}

function requestApiGet(uri, queries = {}) {
    return axios.get(`${APIUrl + '/api'}/${uri}`, {
        headers: this.header(),
        params: queries
    });
}

function requestApiGetCore(uri, queries = {}) {
    return axios.get(`${CoreAPIUrl + '/api'}/${uri}`, {
        headers: this.coreHeader(),
        params: queries
    });
}
function requestApiPostCore(uri, data = {}) {
    return axios.post(`${CoreAPIUrl + '/api'}/${uri}`, data, {
        headers: this.coreHeader(),
    });
}


function requestApiPost(uri, data = {}) {
    return axios.post(`${APIUrl + '/api'}/${uri}`, data, {
        headers: this.header(),
    });
}

function requestApiPostLogin(uri, data = {}) {
    return axios.post(`${APIUrl + '/api'}/${uri}`, data);
}

function requestApiPut(uri, data = {}, queries = {}) {
    return axios.put(`${APIUrl + '/api'}/${uri}`, data, {
        headers: this.header(),
        params: queries
    });
}

function requestApiDelete(uri, queries = {}) {
    return axios.delete(`${APIUrl + '/api'}/${uri}`, {
        headers: this.header(),
        params: queries
    });
}


export default {
    ax,
    saveToken,
    checkToken,
    header,
    coreHeader,
    requestApiGet,
    requestApiPost,
    requestApiPostCore,
    requestApiPostLogin,
    requestApiPut,
    requestApiDelete,
    requestApiGetCore,
}